<template>
    <v-dialog v-model="dialog" persistent max-width="400px">
        <template v-slot:activator="{ on, attrs }">
            <v-btn v-on="on" v-bind="attrs" color="primary">
                배포
            </v-btn>
        </template>
        <v-card>
            <v-card-title>
                <span class="headline">{{ titleComputed }}</span>
            </v-card-title>
            <v-card-text>
                <v-container>
                    <v-row>
                        <v-select
                                v-model="selectedVersionsPC"
                                :items="versionsPC"
                                label="PC version"
                                item-text="raw.versionCode"
                                clearable
                                return-object
                        >
                        </v-select>
                    </v-row>
                    <v-row>
                        <v-select
                                v-model=selectedVersionsDV
                                :items="versionsDV"
                                label="DV version"
                                item-text="raw.versionCode"
                                clearable
                                return-object
                        >
                        </v-select>
                    </v-row>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="dialog = false">닫기</v-btn>
                <v-btn color="blue darken-1" text @click="deploy" :disabled="!validDeploy">배포하기</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import {PATH} from "@/constants";
    import AgentVersion from "@/model/agent-version";

    export default {
        name: "AgentVersionDeployButton",
        props: {
            selected: {
                type: Array,
                default: () => [],
            },
        },
        data() {
            return {
                dialog: false,
                versions: [],
                selectedVersionsPC: undefined,
                selectedVersionsDV: undefined,
            };
        },
        computed: {
            titleComputed() {
                return !this.validSelected ? "선택된 항목이 없습니다." : "버전 배포";
            },

            validSelected() {
                return !this.$isEmpty(this.selected)
            },

            /**
             * 올바른 배포 조건
             *
             * 1. 선택된 항목이 있을 것
             * 2. 선택된 PC 버전 혹은 DV 버전이 있을 것
             */
            validDeploy() {
                return this.validSelected && (this.selectedVersionsPC || this.selectedVersionsDV);
            },

            versionsPC() {
                return this.versions.filter(e => (e.raw.versionType || "").toUpperCase() === "PC");
            },

            versionsDV() {
                return this.versions.filter(e => (e.raw.versionType || "").toUpperCase() === "DV");
            },
        },
        created() {
            this.loadVersions();
        },
        methods: {
            /**
             * 국가별 또는 사업자별인지에 따라 다른 API 를 호출해야 합니다.
             *
             * 그 기준으로
             */
            deploy() {
                if (!this.validDeploy) return;

                let results = [];

                // 선택된 항목의 루프를 돌며 버전을 배포합니다.
                this.selected.forEach(async e => {
                    results.push(await e.deploy(this.selectedVersionsPC, this.selectedVersionsDV));
                });

                // 완료시 첨부할 메시지를 여기에서 작성합니다.
                let message = "";
                results.forEach(e => {
                });

                this.$alert("배포가 완료되었습니다. " + message);
            },

            async loadVersions() {
                const res = await this.$request(PATH.MONITORING.AGENT_VERSION_SIMPLE)
                    .post()
                    .enqueue();
                this.versions = res.data.map(e => new AgentVersion(e));
            },
        }
    }
</script>

<style scoped>

</style>